import { getUuid } from '@kakaopay-common/payweb-bridge';
import { Browser } from '@kakaopay-common/user-agent';

class Uuid {
  // uuid
  private uuid?: string;
  // 불필요한 Uuid 요청을 통제하기 위한 Promise 객체
  private setUuidPromise?: Promise<void>;

  /**
   * 최초 로딩을 조금이라도 빠르게 진행하기 위해 Class 초기화와 동시에 uuid 설정 함수 호출
   */
  constructor() {
    this.setUuid();
  }

  /**
   * 새로운 Uuid를 설정하는 함수.
   * 내부적으로 this.setUuidPromise 변수를 사용하여 한 시점에 한번의 JSAPI만 호출하게끔 한다.
   */
  private async setUuid() {
    if (!this.setUuidPromise) {
      // 현재 진행중인 UUID 갱신 Promise가 없는 경우 토큰갱신 API 호출
      this.setUuidPromise = new Promise((resolve) => {
        getUuid().then((response) => {
          this.uuid = response.result?.uuid;
          resolve();
        });
      });
    }

    // UUID 갱신 Promise 종료될때까지 대기
    await this.setUuidPromise;

    // UUID 갱신 Promise 멤버변수가 남아있는 경우 초기화
    if (this.setUuidPromise) {
      this.setUuidPromise = undefined;
    }
  }

  public async getUuid() {
    // Uuid가 없으면 uuid를 설정한다.
    if (Browser.isKakaoPayWebview() && !this.uuid) {
      await this.setUuid();
    }
    return this.uuid;
  }
}

export default new Uuid();
